import styled, { css, keyframes } from 'styled-components'
import { isTablet } from 'react-device-detect'

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`

// Common button styles for navigation and close buttons
const lightboxButtonBase = css`
  position: absolute;
  color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  padding: 0;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  transition: all 0.2s ease;

  /* vertical centering - use flex for better cross-browser support */
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
`
export const LightboxWrapper = styled.div<{ $isClosing?: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  cursor: pointer;
  animation: ${({ $isClosing }) => ($isClosing ? fadeOut : fadeIn)} 1s ease;

  .lightbox-content {
    position: relative;
    width: 100vw;
    height: 100vh;
    cursor: default;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .lightbox-main {
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width: 100%;
      max-height: 100%;

      img {
        max-width: 80vw;
        max-height: 80vh;
        object-fit: contain;
        border-radius: 8px;
        margin-bottom: 20px;

        ${isTablet &&
        css`
          max-width: 100%;
          max-height: calc(80vh - 120px);
        `}
      }
    }

    .lightbox-info {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 16px;

      .lightbox-inventory {
        color: white;
        font-size: 16px;
        margin: 0;
        text-align: center;
      }

      .lightbox-thumbnails {
        display: flex;
        gap: 12px;
        justify-content: center;

        .lightbox-thumbnail {
          width: auto;
          height: 90px;
          object-fit: cover;
          border-radius: 4px;
          cursor: pointer;
          border: 2px solid transparent;
          transition: all 0.2s ease;

          &:hover {
            transform: scale(1.1);
          }

          &.selected {
            border: 2px solid white;
            box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
          }
        }
      }
    }

    .nav-button {
      ${lightboxButtonBase}
      top: 50%;
      transform: translateY(-50%);
      background-color: transparent;
      border: none;
      font-size: 64px;
      font-weight: lighter;

      &.prev {
        left: 5vh;
      }

      &.next {
        right: 5vh;
      }
    }
  }

  /* Mobile optimizations */
  @media (max-width: 768px) {
    .lightbox-content {
      width: 100vw;
      height: 100vh;

      .lightbox-main {
        img {
          max-width: 90vw;
          max-height: 50vh;
        }
      }

      .nav-button {
        width: 50px;
        height: 50px;

        &.prev {
          left: 10px;
        }

        &.next {
          right: 10px;
        }
      }

      .lightbox-info {
        .lightbox-thumbnails {
          gap: 8px;

          .lightbox-thumbnail {
            width: 50px;
            height: 50px;
          }
        }
      }
    }
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.deviceW.xxl}) {
    .lightbox-content {
      width: 100vw;
      height: 100vh;
      .nav-button {
        &.prev {
          left: 10px;
        }
        &.next {
          right: 10px;
        }
      }
      .lightbox-main {
        img {
          max-width: 80vw;
          max-height: calc(90vh - 120px);
        }
      }
      .close-button {
        top: 15vh;
        right: 4%;
        width: 112px;
        height: 112px;
      }
      .close-button svg {
        width: 50px;
        height: 50px;
      }
    }
  }
`
